import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';

type logInspirationalListClickedParams = {
  carousel_index?: number;
  carousel_length?: number;
  description?: string;
  inspirational_list_type?: string;
  location: CardLocation;
  page_slug: string;
};

/**
 * User click an inspirational list card.
 * @param params - Attributes to log with the amplitude event
 * @param params.carousel_index - Position of card in the carousel user click on (starting with 0)
 * @param params.carousel_length - Total number of cards in the carousel.
 * @param params.description - Description of inspirational list clicked by user
 * @param params.inspirational_list_type - Inspirational list type of the page (programmatic list, sponsored list, trail, etc,), passed from server
 * @param params.location - The location of the inspirational list carousel
 * @param params.page_slug - Page slug of inspirational list clicked by user
 */
const logInspirationalListClicked = (
  { carousel_index, carousel_length, description, inspirational_list_type, location, page_slug }: logInspirationalListClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'inspirational list clicked',
    {
      'carousel index': carousel_index,
      'carousel length': carousel_length,
      description,
      'inspirational list type': inspirational_list_type,
      location,
      'page slug': page_slug
    },
    callback
  );
};

export default logInspirationalListClicked;
